<template>
  <v-form lazy-validation @submit.prevent="next">
    <v-layout wrap row justify-center>
      <v-flex xs12 sm9 lg9>
        <v-select
          :items="levels"
          item-text="typeLevel"
          v-model="v.level.$model"
          label="Selecciona el nivel"
          required
          :error-messages="levelErrors"
          return-object
          @change="getGroupsByLevel"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm9 lg9>
        <v-select
          @change="$forceUpdate()"
          no-data-text="No hay grupos"
          return-object
          :items="grades"
          item-text="name"
          v-model="v.grade.$model"
          label="Selecciona el grupo"
          :error-messages="groupErrors"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm9 lg9>
        <v-select
          @change="createDays"
          :items="dividers"
          v-model="v.divider.$model"
          label="Número de subgrupos"
          :error-messages="dividerErrors"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap row justify-center>
      <v-flex xs12 sm9 lg9>
        <v-radio-group
          v-model="v.order.$model"
          color="primary"
          :error-messages="orderErrors"
        >
          <v-radio
            color="primary"
            label="Aleatoriamente"
            value="RANDOM"
          ></v-radio>
          <v-radio
            color="primary"
            label="Alfabéticamente"
            value="ALPHABETICAL"
          ></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["v", "subgroup", "levels"],
  data: () => ({
    grades: [],
    dividers: [2, 3, 4, 5, 6, 7, 8],
  }),
  computed: {
    nameErrors() {
      if (this.v.name.$dirty && !this.v.name.$model) {
        return ["Nombre requerido"];
      }
      return [];
    },
    levelErrors() {
      if (this.v.level.$dirty && !this.v.level.$model) {
        return ["Nivel es requerido"];
      }
      return [];
    },
    groupErrors() {
      // if(this.v.grade.$dirty && !this.v.grade.$model){
      //     return ["Grupo es requerido"];
      // }
      return [];
    },
    dividerErrors() {
      if (this.v.divider.$dirty && !this.v.divider.$model) {
        return ["Número de subgrupos es requerido"];
      }
      return [];
    },
    orderErrors() {
      if (this.v.order.$dirty && !this.v.order.$model) {
        return ["Ordenamiento requerido"];
      }
      return [];
    },
    ...mapGetters(["getUser"]),
  },
  methods: {
    createDays(divider) {
      this.subgroup.days = [];
      for (var i = 0; i < divider; i++) {
        this.subgroup.days.push({
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
        });
      }
    },
    
    getGroupsByLevel(level) {
      this.grades = [];
      this.v.grade.$model = "";
      this.$store
        .dispatch("subgroups/posibleGradeGroupsAll", { idLevel: level.id })
        .then((response) => {
          var _this = this;
          var gg = response.data.items;
          for (var i = 0; i < gg.length; i++) {
            gg[i].name = gg[i].grade + " " + gg[i].group;
            _this.grades.push(gg[i]);
          }
          this.$forceUpdate();
        })
        .catch((error) => {
          this.grades = [];
          console.log(error);
        });
    },
  },
};
</script>

<style>
</style>
